export const saveAccessToken = (token) => {
  localStorage.setItem("access_token", token);
};

export const removeAccessToken = () => {
  localStorage.removeItem("access_token");
};

export const getAccessToken = () => localStorage.getItem("access_token");
